import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import ReactModal from "react-modal";
import {
  Add_Community,
  Community_List,
  Update_Community,
  communityList_Status,
} from "../../../actions/auth";
import { useDispatch } from "react-redux";
import swal from "sweetalert";
import { MY_PROFILE_COMMUNITY } from "../../../actions/types";
import moment from "moment";
import Pagination from "react-js-pagination";

import DatePicker from "react-date-picker";
import { Link } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { useHistory } from "react-router-dom";
import Spinner from "../Spinner";
import imageCompression from "browser-image-compression";

const Community = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpen2, setModalIsOpen2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [name, setName] = useState("");
  const [List, setList] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);

  const [activePage, setActivePage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [total, setTotal] = useState("");
  const [searchData, setSearchData] = useState("");
  const [sortOrder, setSortOrder] = useState(""); // 'asc' or 'desc'
  const [sortField, setSortField] = useState(""); // 'asc' or 'desc'
  const [errorMessage, setErrorMessage] = useState("");
  const [imgError, setImgError] = useState("");
  const [description, setDescription] = useState(""); // State for the description input
  const [descError, setDescError] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [dateError, setDateError] = useState(""); // To show validation error message
  const [status, setStatus] = useState(""); // To show validation error message

  const dispatch = useDispatch();
  const history = useHistory();

  const formatDate = (date) => {
    if (!date) return ""; // Handle null or undefined dates
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Get month and pad with leading zero
    const day = String(d.getDate()).padStart(2, "0"); // Get day and pad with leading zero
    const year = d.getFullYear(); // Get year
    return `${month}-${day}-${year}`; // Format as MM-DD-YYYY
  };

  useEffect(() => {
    setLoadingData(true);
    // setLoading(true);
    dispatch(
      Community_List(
        status,
        activePage,
        itemsPerPage,
        searchData ? searchData : " ",
        sortOrder || "",
        sortField || "",
        formatDate(fromDate || ""), // Format the fromDate
        formatDate(toDate || "")
      )
    ).then((response) => {
      if (response.success == true) {
        setTotal(response.meta.totalCount);
        setList(response.data);
        setLoadingData(false);
      }
    });
  }, [activePage, total, searchData, fromDate, toDate]);

  const searchList = (e) => {
    const data = e.target.value.trimStart();

    // setTimeout(() => {
    //   if(e.target.value == "" && total != ){

    //   }
    // },[])

    setSearchData(data);
    setActivePage(1);
    if (data) {
      dispatch(
        Community_List(
          status,
          1,
          itemsPerPage,
          e.target.value,
          sortOrder || "",
          sortField || "",
          formatDate(fromDate || ""), // Format the fromDate
          formatDate(toDate || "")
        )
      ).then((response) => {
        if (response.success == true) {
          setTotal(response.meta.totalCount);
          setList(response.data);
        }
      });
    }
  };

  const handleClearSearch = () => {
    if (searchData) {
      setSearchData("");
      setLoading(true);
      dispatch(
        Community_List(
          status,
          activePage,
          itemsPerPage,
          "",
          sortOrder || "",
          sortField || "",
          formatDate(fromDate || ""), // Format the fromDate
          formatDate(toDate || "")
        )
      ).then((response) => {
        if (response.success) {
          setTotal(response.meta.totalCount);
          setList(response.data);
        }
        setLoading(false); // Stop loading
      });
    }
  };
  const [EditID, setEditId] = useState("");
  const openModal = (isEdit = false, data = null) => {
    setIsEditMode(isEdit);
    if (isEdit && data) {
      setName(data && data.name);
      setDescription(data?.description || "");
      setImage(
        data?.image ? MY_PROFILE_COMMUNITY + data?.image : "img/noImage.png"
      );

      setEditId(data?._id);
    } else {
      setName("");
      setDescription("");
      setImage("");
      // setSelectedRadarId(null);
    }
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setName("");
    setDescription("");
    setImage("");
    setDescError("");
    setErrorMessage("");
    setImgError("");
    // setError("");
    // document.body.style.overflow = "auto";
  };

  const handleName = (e) => {
    const value = e.target.value.trimStart();
    setName(value);
    // Validation logic
    if (!value) {
      setErrorMessage(
        "Community Title cannot be blank. Please provide a title."
      );
    } else if (
      !/^[a-zA-Z0-9\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value)
    ) {
      setErrorMessage(
        "Invalid Community Title. Ensure it contains only letters, numbers, and allowed special characters."
      );
    } else if (value.length < 2) {
      setErrorMessage("Community Title must be at least 2 characters long.");
    } else if (value.length > 150) {
      setErrorMessage("Community Title cannot exceed 150 characters.");
    } else {
      setErrorMessage(""); // Clear the error message if valid
    }
  };

  const handleDescription = (e) => {
    const value = e.target.value.trimStart(); // Get the trimmed value
    // Validate the description
    if (!value) {
      setDescError("Description cannot be blank. Please provide details.");
    } else if (!/^[a-zA-Z0-9\s.,!?'"’‘"\-]*$/.test(value)) {
      // Allow letters, numbers, spaces, and common punctuation
      setDescError(
        "Invalid description. Only letters, numbers, spaces, and common punctuation are allowed."
      );
    } else if (value.length < 2) {
      setDescError("Description must be at least 2 characters long.");
    } else if (value.length > 500) {
      setDescError("Description cannot exceed 500 characters.");
    } else {
      setDescError(""); // Clear the error if all validations pass
    }

    setDescription(value); // Update the description state
  };

  const refreshCommunityList = () => {
    setLoadingData(true);
    dispatch(
      Community_List(
        status,
        activePage,
        itemsPerPage,
        searchData || "",
        sortOrder || "",
        sortField || "",
        formatDate(fromDate || ""),
        formatDate(toDate || "")
      )
    ).then((response) => {
      if (response.success) {
        setTotal(response.meta.totalCount);
        setList(response.data);
        setLoadingData(false);
      }
    });
  };

  const [isUpdating, setIsUpdating] = useState(false);
  const handleSubmit = () => {
    // For new community creation
    if (!isEditMode) {
      // Validate all required fields for new community
      if (!image) {
        setImgError("Please upload an image. This field cannot be left blank.");
        // return;
      }
      if (!name) {
        setErrorMessage(
          "Community Title cannot be blank. Please provide a title."
        );
        // return;
      }
      if (!description) {
        setDescError("Description cannot be blank. Please provide details.");
        // return;
      }
    }

    const userrole =
      localStorage.getItem("Role_user_Auth") == 2 ? "admin" : "super_admin";
    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("user_type", userrole);

    // Only append image if a new one was selected
    if (sendImg) {
      formData.append("image", sendImg);
    }

    // For new community, check all fields
    if (
      !isEditMode &&
      (!name ||
        !description ||
        !sendImg ||
        imgError ||
        errorMessage ||
        descError)
    ) {
      return;
    }

    // For editing, only check if there are any validation errors
    if (isEditMode && (imgError || errorMessage || descError)) {
      return;
    }

    if (isEditMode) {
      if (isUpdating) return;
      setIsUpdating(true);
      setLoadingData(true);
      dispatch(Update_Community(formData, EditID))
        .then((response) => {
          setLoadingData(true);
          if (response.success) {
            setList(response?.data);
            setModalIsOpen(false);
            setLoadingData(false);

            swal({
              title: "",
              text: "Community updated successfully",
              icon: "success",
              button: {
                text: "OK",
                closeModal: true,
              },
              closeOnClickOutside: false,
            }).then((e) => {
              if (e) {
                setModalIsOpen(false);
                refreshCommunityList();
              }
            });
          }
        })
        .catch(() => {
          setIsUpdating(false);
        })
        .finally(() => {
          setIsUpdating(false);
          setLoadingData(false);
        });
    } else {
      setLoadingData(true);
      dispatch(Add_Community(formData))
        .then((response) => {
          debugger;
          if (response?.success === true) {
            setList(response?.data);
            setModalIsOpen(false);
            setLoadingData(false);
            swal({
              title: "",
              text: "Community added successfully.",
              icon: "success",
              button: {
                text: "OK",
                closeModal: true,
              },
              closeOnClickOutside: false,
            }).then((e) => {
              if (e) {
                setModalIsOpen(false);
                refreshCommunityList();
              }
            });
          } else if (response?.success === false) {
            swal({
              title: "",
              text: response?.message || "Something went wrong",
              icon: "error",
              button: "OK",
            });
            setLoadingData(false);
            setModalIsOpen(false);
          }
        })
        .catch((error) => {
          setLoadingData(false);
        });
    }
  };

  function toggleSwitch(e, event) {
    // const newStatusText = event.target.checked == true ? "1" : "0";
    const newStatusText2 = event.target.checked == true ? "active" : "inactive";

    document.body.classList.add("swal-open-modal");

    swal({
      text: `Are you sure you want to ${newStatusText2} this status?`,
      icon: "warning",
      buttons: true,
      className: "swal-custom-modal",
    }).then((willConfirm) => {
      document.body.classList.remove("swal-open-modal");
      setStatus(newStatusText2);
      if (willConfirm) {
        // setLoadingData(true);

        dispatch(communityList_Status(e?._id, newStatusText2)).then(
          (response) => {
            if (response) {
              // setLoadingData(true);
              dispatch(
                Community_List(
                  newStatusText2,
                  activePage,
                  itemsPerPage,
                  searchData ? searchData : "",
                  sortOrder || "",
                  sortField || "",
                  formatDate(fromDate || ""), // Format the fromDate
                  formatDate(toDate || "")
                )
              ).then((response) => {
                if (response.success == true) {
                  setTotal(response.meta.totalCount);
                  swal("", "Community status updated successfully", "success");
                  setList(response.data);
                  // setLoadingData(false);
                }
              });
            }
          }
        );
      }
    });
  }

  const calculateRange = () => {
    const currentPage = activePage;
    const itemsPerPage = 10;

    const startIndex = (currentPage - 1) * itemsPerPage + 1;

    let endIndex = currentPage * itemsPerPage;
    if (endIndex > total) {
      endIndex = total;
    }

    return `Showing ${startIndex} to ${endIndex} of ${total} entries`;
  };

  const handlePageChange = (pagenumber) => {
    if (pagenumber) {
      setLoadingData(true);
      dispatch(
        Community_List(
          status,
          pagenumber,
          itemsPerPage,
          searchData ? searchData : "",
          sortOrder || "",
          sortField || "",
          formatDate(fromDate || ""), // Format the fromDate
          formatDate(toDate || "")
        )
      ).then(() => {
        setLoadingData(false); // Stop loading
      });
      setActivePage(pagenumber);
    }
  };

  const Sortt = (col) => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc"; // Toggle sort order
    // const newSortOrder = sortOrder === "desc" ? "asc" : "desc"; // Toggle sort order

    setSortField(col);
    setSortOrder(newSortOrder);
    // setLoadingData(true);
    dispatch(
      Community_List(
        status,
        activePage,
        itemsPerPage,
        searchData ? searchData : "",
        newSortOrder,
        col,
        fromDate || "",
        toDate || ""
      )
    ).then((response) => {
      if (response.success == true) {
        setTotal(response.meta.totalCount);
        setList(response.data);
        // setLoadingData(false);
      }
    });
  };

  const handleFromDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      setFromDate(date);
    }
    if (!toDate) {
      setDateError("Please select To Date Also.");
    } else {
      setDateError(""); // Clear error if To Date is selected
    }

    if (!fromDate) {
      setDateError(""); // If no fromDate is selected, clear the error
    } else {
      setDateError(""); // Clear error when To Date is selected
    }
    if (!date) {
      setFromDate(null);
      setToDate(null); // Reset end date when start date is removed
    }
    // if (toDate && date > toDate) {
    //   setToDate(null); // Reset toDate if it's earlier than fromDate
    // }
  };
  const handleToDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      setToDate(date);
    }
    setDateError(""); // Clear error when To Date is selected
    if (!fromDate) {
      setDateError(""); // If no fromDate is selected, clear the error
    } else {
      setDateError(""); // Clear error when To Date is selected
    }
  };

  const [image, setImage] = useState(""); // Default profile image
  const [sendImg, setSendImg] = useState("");

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/jpeg, image/png ,image/heic",
    maxSize: 25 * 1024 * 1024, // 25MB

    onDrop: async (acceptedFiles, rejectedFiles) => {
      if (rejectedFiles.length > 0) {
        const { file, errors } = rejectedFiles[0];
        if (file.size > 25 * 1024 * 1024) {
          setImgError("The uploaded file size cannot exceed 25 MB.");
          return;
        }
        if (
          !["image/jpeg", "image/jpg", "image/png", "image/heic"].includes(
            file.type
          )
        ) {
          setImgError(
            "Invalid image format. Please upload a JPG, PNG, or HEIC file."
          );
          return;
        }
      }
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        if (file.size > 25 * 1024 * 1024) {
          setImgError("The uploaded file size cannot exceed 25 MB.");
          return;
        }

        // Provide immediate feedback
        const blobUrl = URL.createObjectURL(file);
        setImage(blobUrl); // Set the preview image immediately

        try {
          // Compress the image
          const options = {
            maxSizeMB: 1, // Maximum size in MB
            maxWidthOrHeight: 1920, // Max width or height
            useWebWorker: true, // Use web worker for compression
          };
          const compressedFile = await imageCompression(file, options);
          setSendImg(compressedFile);
        } catch (error) {
          setImgError("Failed to compress the image. Please try again.");
        }
      }
    },
  });

  const handleRemoveImage = () => {
    setImage(""); // Reset to default profile image
    setImgError("Please upload an image. This field cannot be left blank.");
  };

  return (
    <>
      <ReactModal
        isOpen={modalIsOpen}
        style={{
          overlay: {
            background: "rgba(0, 0, 0, .50)",
            zIndex: "999",
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            minWidth: "570px",
            border: "none",
            padding: "0px",
            animation: "pop-up 0.5s forwards",
            overflow: "hidden",
          },
        }}
      >
        <div className="modal-header pb-3">
          <h6 className="modal-title">
            {" "}
            {isEditMode ? "Edit Community" : "Add Community"}
          </h6>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-content border-0">
          <div className="modal-body">
            <form>
              <div className="image-upload-modal">
                <label className="text-black fw-bold mb-2">
                  Upload Image <span className="redErrMsg"> *</span>
                </label>
                <div className="upload-container" {...getRootProps()}>
                  <input {...getInputProps()} />

                  <div className="profile-upload-wrapper">
                    <img src={image} className="profile-upload-image" />
                    <div className="upload-overlay">
                      <p>Click or Drag to Upload</p>
                    </div>
                    {image && (
                      <span className="remove-icon" onClick={handleRemoveImage}>
                        &times;
                      </span>
                    )}
                  </div>
                </div>
                {imgError && <p className="text-danger">{imgError}</p>}
              </div>

              <div className="mb-3">
                <label className="text-black fw-bold mb-2">
                  Community Title
                  <span className="redErrMsg"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter a community name"
                  className="form-control"
                  value={name}
                  onChange={handleName}
                  maxLength={150}
                  // onKeyDown={handleKeyPress}
                />
                {errorMessage && <p className="text-danger">{errorMessage}</p>}
              </div>
              <div className="mb-3">
                <label className="text-black fw-bold mb-2">
                  Description
                  <span className="redErrMsg"> *</span>
                </label>
                <textarea
                  type="textarea"
                  placeholder="Community Description"
                  className="form-control"
                  value={description}
                  onChange={handleDescription}
                  maxLength={500}
                  // onKeyDown={handleKeyPress}
                />
                {descError && <p className="text-danger">{descError}</p>}
              </div>
            </form>
          </div>
        </div>
        <div className="modal-footer pt-3">
          <button type="button" className="btn btn-light" onClick={closeModal}>
            Cancel
          </button>
          {!descError && !errorMessage && !imgError ? (
            <button
              type="button"
              className="btn btn-primary ms-2"
              onClick={handleSubmit}
              disabled={isUpdating}
            >
              {isEditMode ? "Edit Community" : "Add Community"}
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-primary ms-2"
              onClick={handleSubmit}
              disabled
            >
              {isEditMode ? "Edit Community" : "Add Community"}
            </button>
          )}
        </div>
      </ReactModal>

      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n\n.react-date-picker__wrapper{\nborder:0px !important;\n}\n",
        }}
      />
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Community
                  </h6>
                </div>
                <div className="card-body">
                  <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <div className="row mb-2 ">
                      <div className="col-md-4">
                        <label>Search:</label>

                        <input
                          type="text"
                          className="form-control search-input-new"
                          placeholder="Enter community name to search"
                          value={searchData}
                          onChange={searchList}
                          // onKeyDown={handleSearch}
                        />
                        {searchData?.length >= 1 && (
                          <div
                            onClick={handleClearSearch}
                            // className="cross-serach-new"
                            style={{
                              position: "absolute",
                              top: "40px",
                              right: "26px",
                            }}
                          >
                            <i className="fa fa-times cursor-pointerr"></i>
                          </div>
                        )}
                      </div>
                      {/* <div className="row mb-2 "> */}
                      <div className="col-3">
                        <label>Start Date:</label>
                        <DatePicker
                          className="form-control"
                          // selected={fromDate}
                          value={fromDate}
                          onChange={handleFromDateChange}
                          maxDate={new Date()}
                          minDate={new Date(2015, 0, 1)}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>

                      <div className="col-3">
                        <label>End Date:</label>
                        <DatePicker
                          className="form-control"
                          // selected={selectedDate}
                          value={toDate}
                          disabled={!fromDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        {dateError && (
                          <p className="text-danger">{dateError}</p>
                        )}
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary form-control"
                          style={{ marginTop: "1.9rem" }}
                          onClick={() => openModal(false)}
                          // onKeyDown={handleSearch}
                        >
                          Add Community
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {loadingData ? (
                  <div className="loader-container mt-5">
                    <div className="loaderss"></div>
                  </div>
                ) : (
                  <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                    <table class="table radar-table">
                      <thead>
                        <tr>
                          <th scope="col">No. </th>
                          <th scope="col">
                            Community Name{" "}
                            <i
                              onClick={() => Sortt("name")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>{" "}
                          </th>
                          <th scope="col">
                            Created at{" "}
                            <i
                              onClick={() => Sortt("created_at")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>{" "}
                          </th>
                          <th scope="col">
                            Total Member{" "}
                            <i
                              onClick={() => Sortt("total_members")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>{" "}
                          </th>
                          <th scope="col">Status</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <>
                          {loadingData ? (
                            <div className="overlay">
                              <div className="loader bg-transparent">
                                <Spinner />
                              </div>
                            </div>
                          ) : List?.length > 0 ? (
                            List.map((e, index) => (
                              <tr key={e._id}>
                                <th scope="row">
                                  {(activePage - 1) * itemsPerPage +
                                    (index + 1)}
                                </th>
                                <td className="cursor-pointerr">
                                  <Link
                                    to={{
                                      pathname: "/GetAllPosts",
                                      state: e, // Pass the data here
                                    }}
                                  >
                                    <img
                                      src={
                                        e?.image
                                          ? `${MY_PROFILE_COMMUNITY}${e?.image}`
                                          : "img/noImage.png"
                                      }
                                      onError={(e) => {
                                        e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                                        e.target.src = "img/noImage.png"; // Fallback image if loading fails
                                      }}
                                      style={{
                                        height: "50px",
                                        borderRadius: "50px",
                                        width: "50px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    {e?.name}
                                  </Link>
                                </td>
                                <td>
                                  {moment(e?.created_at_formatted).format(
                                    "MM/DD/YYYY"
                                  )}
                                </td>
                                <td>{e?.total_members}</td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input cursor-pointerr"
                                      type="checkbox"
                                      key={e?._id}
                                      role="switch"
                                      id="flexSwitchCheckDefault"
                                      checked={
                                        e?.status == "inactive" ? false : true
                                      }
                                      defaultChecked={
                                        e?.status == "inactive" ? false : true
                                      }
                                      onClick={(event) =>
                                        toggleSwitch(e, event)
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  <i
                                    onClick={() => openModal(true, e)}
                                    className="fas fa-edit cursor-pointerr"
                                  ></i>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={6}>
                                <h5
                                  style={{ textAlign: "center" }}
                                  className="mt-3"
                                >
                                  No communities found
                                </h5>
                              </td>
                            </tr>
                          )}
                        </>
                      </tbody>
                    </table>
                    {List && List?.length > 0 ? (
                      <div className="d-flex justify-content-between mt-3 align-items-center">
                        <ul className="mt-3 ps-0">
                          <p>
                            {/* {list && list?.data?.totalOptions > 0 */}
                            {calculateRange()}
                            {/* : ""} */}
                          </p>
                        </ul>
                        <Pagination
                          activePage={activePage}
                          itemsCountPerPage={itemsPerPage}
                          totalItemsCount={total}
                          pageRangeDisplayed={10}
                          // onChange={handlePageChange}
                          onChange={
                            total > itemsPerPage ? handlePageChange : null
                          }
                          itemClass={`page-item ${
                            total <= itemsPerPage ? "noPointerrr" : ""
                          }`}
                          linkClass={
                            total && total > 0
                              ? "page-link"
                              : "page-link disabled"
                          }
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Community;
